import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  BASE_IMAGES_URL,
  APP_API_KEY,
} from "../../../../../../common/constants";

class MostActiveUserItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    var { values } = this.props;
    var img = `${BASE_IMAGES_URL}/users/${values.userid}.jpg?api_key=${APP_API_KEY}`;

    return (
      <>
        <tr className="bg-white border-b-2 border-gray-50 cursor-pointer hover-all">
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {values.username}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {values.email}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            <img
              className="w-20 h-20 flex-shrink-0 ml-2 rounded-full"
              src={img}
              alt=""
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "../images/user_1.png";
              }}
            />
          </td>
        </tr>
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var { session, user } = state;
  // console.log('customerlistingtabs',state.customerlistingtabs);
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    localCurrency: state.currency,
  };
}
export default connect(mapStateToProps, {})(MostActiveUserItems);
